import { createApiClient } from "@/utils/api";
import type {
  ListPlansRequest,
  ListPlansResponse,
  Plan,
  UpdatePlanRequest,
} from "@/gen/api/v1/plan_pb";
import { PlanService } from "@/gen/api/v1/plan_pb";
import { IDRequest } from "@/gen/api/v1/common_pb";
import type { Empty } from "@bufbuild/protobuf/wkt";

const client = createApiClient(PlanService);

export const planService = {
  listPlans: (request: ListPlansRequest): Promise<ListPlansResponse> => {
    return client.listPlans(request);
  },
  createPlan: (request: Plan): Promise<Plan> => {
    return client.createPlan(request);
  },
  getPlan: (request: IDRequest): Promise<Plan> => {
    return client.getPlan(request);
  },
  deletePlan: (request: IDRequest): Promise<Empty> => {
    return client.deletePlan(request);
  },
  updatePlan: (request: UpdatePlanRequest): Promise<Plan> => {
    return client.updatePlan(request);
  },
};

export type {
  ListPlansRequest,
  ListPlansResponse,
  Plan,
  IDRequest,
  UpdatePlanRequest,
  Empty,
};
